import { render, staticRenderFns } from "./EditGroupModal.html?vue&type=template&id=05924fd0&scoped=true&external"
import script from "./EditGroupModal.vue?vue&type=script&lang=js"
export * from "./EditGroupModal.vue?vue&type=script&lang=js"
import style0 from "./EditGroupModal.scss?vue&type=style&index=0&id=05924fd0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05924fd0",
  null
  
)

export default component.exports